<template>
  <div class="flex items-center">
    <nuxt-link
      v-if="to"
      :to="to"
      :class="active ? 'text-gray-700 hover:text-gray-900' : 'text-gray-500 hover:text-gray-600'"
      class="trans-hover pr-2"
    >
      <slot />
    </nuxt-link>
    <span v-else :class="active ? 'text-gray-700' : 'text-gray-500'" class="trans-hover pr-2">
      <slot />
    </span>
    <i v-if="!active" class="fas fa-chevron-right mr-2 text-xs text-gray-600" />
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
